import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import * as FromData from "./data/reducer";
import { reducer as dataReducer } from "./data/reducer";
import clockReducer from "./scenes/Clock/reducer";
import adminReducer from "./scenes/Admin/reducer";
import inventoryReducer from "./scenes/Inventory/reducer";
import toolsReducer from "./scenes/Tools/reducer";
import { localizeReducer } from "react-localize-redux";

// -----------------------------------------------------------------------------
// REDUCER

export default combineReducers({
    routing: routerReducer,
    data: dataReducer,
    clock: clockReducer,
    admin: adminReducer,
    inventory: inventoryReducer,
    tools: toolsReducer,
    localize: localizeReducer
})


// -----------------------------------------------------------------------------
// PUBLIC SELECTORS

// Loading
export function isLoadingUser(store) {
    return FromData.isLoadingUser(store.data);
}

export function isLoadingClock(store) {
    return FromData.isLoadingClock(store.data);
}

// User

export function getUser(store) {
    return FromData.getUser(store.data);
}

export function isAdmin(store) {
    return FromData.isAdmin(store.data);
}

export function hasPermission(store, permission) {
    return FromData.hasPermission(store.data, permission);
}

export function getUserToken(store) {
    return FromData.getUserToken(store.data);
}

export function isLoggedIn(store) {
    return FromData.isLoggedIn(store.data);
}



// WEBPACK FOOTER //
// ./src/reducer.js